import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { AppRemixIcon } from '@/layout/AppComponents';
import * as currentPageAction from '../../../../../../store/actions/currentPageAction';
import AuxSidebar from '../../../../../Sidebar/AuxSidebar';
import { path } from '../../../../../../routing/helpers/router';
import Translator from '../../../../../components/helpers/Translator';
import GenerateReport from '../Reports/GenerateReport';
import _ from 'lodash';

const ReportSidebarBlock = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { moduleBridgeHex, filtersHex } = useParams();
  const auxSidebar = useSelector(
    (state) => state.currentPage?.auxSidebar?.opened
  );
  const reportPermissions = useSelector(
    (state) => state.module[moduleBridgeHex]?.permissions?.ggcl?.reports
  );
  const [openOnce, setOpenOnce] = useState(false);

  const handleAuxSidebar = () => {
    if (!openOnce) {
      setOpenOnce(true);
    }
    if (auxSidebar !== 'reports') {
      dispatch(currentPageAction.change('auxSidebar', { opened: 'reports' }));
    } else {
      dispatch(currentPageAction.change('auxSidebar', { opened: null }));
    }
  };

  const removeFilters = useCallback(
    () =>
      navigate(
        path({
          name: 'user_module_globalLegalCompliance_evaluation',
          params: {
            moduleBridgeHex,
            page: 1,
            filtersHex: 0,
          },
        })
      ),
    [moduleBridgeHex]
  );

  return (
    <>
      <li
        className={auxSidebar && auxSidebar === 'reports' ? 'active' : ''}
        onClick={handleAuxSidebar}
      >
        <span className="sidebar-element">
          <AppRemixIcon icon="file-chart" className="sidebar-icon" />{' '}
          <span className="sb-title">
            <Translator file="user" name="user.export.gcl" />
          </span>
        </span>
      </li>
      <AuxSidebar
        title={<Translator file="user" name="user.export.gcl" />}
        isOpen={auxSidebar && auxSidebar === 'reports'}
        width="350px"
        position="left"
        onClose={handleAuxSidebar}
      >
        {openOnce && (
          <>
            {filtersHex != 0 && (
              <div
                className="alert alert-danger alert-dismissible fade show"
                role="alert"
              >
                <Translator
                  file="module-legalCompliance"
                  name="module.lc.export-filtered.selected-filters"
                />
                <button
                  type="button"
                  className="close"
                  onClick={removeFilters}
                >
                  <AppRemixIcon icon="delete-bin-6" size={16} />
                </button>
              </div>
            )}
            {_.map(reportPermissions, (val, reportType) => {
              if (val && reportType != 0) {
                return (
                  <React.Fragment key={reportType}>
                    <GenerateReport reportType={reportType} />
                  </React.Fragment>
                );
              }
            })}
          </>
        )}
      </AuxSidebar>
    </>
  );
};
export default ReportSidebarBlock;
